import React from 'react'


export default function Footer() {

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    function handleMenuItemClick() {
        scrollToTop();
        // additional code to open the page
    }

    return (
        <>
            <footer id="tg-footer" className="tg-footer tg-haslayout">

                <div className="tg-footerbar">
                    <a id="tg-btnscrolltop" className="tg-btnscrolltop" href="#home" onClick={handleMenuItemClick}><i
                        className="icon-chevron-up"></i></a>
                    <div className="container">
                        <div className="row">
                            <ul className="tg-socialicons pull-right">
                                <li className="tg-facebook"><a href="https://www.facebook.com/CDRI.world/" target="_blank"><i className="fa fa-facebook"></i></a>
                                </li>
                                <li className="tg-twitter"><a href="https://twitter.com/cdri_world" target="_blank"><i className="fa fa-twitter"></i></a></li>
                                <li className="tg-linkedin"><a href="https://www.linkedin.com/company/coalition-for-disaster-resilient-infrastructure/" target="_blank"><i className="fa fa-linkedin"></i></a>
                                </li>

                                <li className="tg-youtube"><a href="https://www.youtube.com/channel/UCh44NgGlVNdx0rtwel9OFvA" target="_blank"><i className="fa fa-youtube"></i></a></li>
                            </ul>
                            <p className="tg-copyrights pull-left">All Rights Reserved ©2023 ICDRI</p>
                        </div>
                    </div>
                </div>

            </footer>
        </>
    )
}
